import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Column from "@amzn/meridian/column";
import { INBOUND_ROUTES } from "../util/RouteConstants";
import { PAGE_HEADERS } from "../util/Constants";
import Navigation from "../util/Navigation";
import PageHeader from "../util/PageHeader";
import { InboundFilterProvider } from "./context/InboundFilterContext";
import { InboundDataProvider } from "./context/InboundDataContext";
import { useDeviceLayout } from "../common/context/DeviceLayoutContext";

const Inbound = ({ location, history }) => {
    const { spacingInset_shorthand2 } = useDeviceLayout();
    
    return (
        <InboundFilterProvider>
            <InboundDataProvider>
                <Column spacing={"medium"} spacingInset={spacingInset_shorthand2}>
                    <PageHeader {...PAGE_HEADERS.INBOUND} />
                    <Navigation routes={INBOUND_ROUTES} location={location} history={history} />
                    <Switch>
                        {INBOUND_ROUTES.map((route, index) => {
                            return <Route key={index} path={route.path} component={route.component} />
                        })}
                    </Switch>
                </Column>
            </InboundDataProvider>
        </InboundFilterProvider>
    );
};

export default Inbound;



// WEBPACK FOOTER //
// ./src/components/inbound/Inbound.js